module.exports = __webpack_public_path__ + "static/media/product2.5469cf03.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/product2.png
// module id = 527
// module chunks = 0